<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Who's Participating"
    seFeDataSubtitle="Choose between My Child or Myself"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-household-setup-whos-participating></se-po-household-setup-whos-participating>
  </se-fe-card-content>
</se-fe-card>
